<script setup>
import { Empty } from "@/shared/ui/empty";

defineProps({
  statementNotFound: { type: Boolean, default: false },
  existingCaseFound: { type: Boolean, default: false },
  checkResults: { type: Object, default: null },
  isTestamentAuthor: { type: Boolean, default: false },
});

defineEmits([
  "export-report",
  "show-existing-case-info",
  "show-notary-data",
  "attach-testament",
  "open-testament-document",
]);
</script>

<template>
  <Empty>
    {{ $t("Раздел недоступен в кабинете клиента") }}
  </Empty>
</template>
